import {Expose} from 'class-transformer';

export class PaymentRefundPaymentApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
